import { combineReducers } from 'redux';
import userReducer from './userReducer';
import doctorReducer from './doctorReducer';

export default combineReducers({
    user: userReducer,
    doctor: doctorReducer,
});
